import ReactSelect from "react-select";
import styled from "styled-components";

export const FilterContainer = styled.div`
  padding: 12px;
  margin-bottom: 12px;
  background: #F9FAFC;
`

export const FilterLabel = styled.span`
  display: block;
  margin: 5px 0;
  font-size: 18px;
  font-weight: 700;
`

export const FilterInput = styled.input`
  width: 100%;
  padding: 6px 12px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  box-sizing: border-box;

  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`

export const FilterSelect = styled(ReactSelect)`
  height: 41px;
`

export const FilterButtonsContainer = styled.div`
  display: flex;
  justify-content: start;
  gap: 20px;

  @media (max-width: 578px) {
    justify-content: space-between;
  }
`

export const FilterButton = styled.button<{ outline?: boolean }>`
  font-family: 'FuturaPT', sans-serif;
  -webkit-tap-highlight-color: white;
  box-sizing: border-box;
  overflow: visible;
  text-transform: none;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  border: 3px solid ${({ outline }) => outline ? "#0a2240" : "transparent"};
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: ${({ outline }) => outline ? "#fff" : "#0a2240"};
  padding: 5px 0px;
  width: 150px;
  color: ${({ outline }) => outline ? "#0a2240" : "#fff"};
  cursor: pointer;
  width: 200px;

  @media (max-width: 578px) {
    width: 150px;
    font-size: 16px;
  }
`
